<template>
  <Head title="Login - Prova"></Head>
  <div class="login-page-wrapper">
    <div class="login-container">
    <div class="login-card">
      <div class="logo-section">
        <img src="/admin/images/logo.svg" alt="Habilite-se" />
      </div>

      <!-- Erro genérico -->
      <div v-if="error_login" class="info-box" style="background: #fee; border-left-color: #dc3545; color: #c33; margin-bottom: 20px;">
        <div v-html="error_login"></div>
      </div>
      <div v-if="wsOnline">
          <form @submit.prevent="handleSubmit">
            <!-- Campo CPF -->
            <div class="form-group">
              <label for="cpf">CPF</label>
              <div>
                <input
                  id="cpf"
                  v-model="cpf"
                  type="text"
                  name="cpf"
                  class="form-control"
                  :class="{ 'is-invalid': error_input.cpf }"
                  placeholder="000.000.000-00"
                  maxlength="14"
                  autocomplete="off"
                  @input="handleCPFInput"
                />
              </div>
              <span v-if="error_input.cpf" class="field-error">{{ error_input.cpf[0] }}</span>
            </div>

            <!-- Botão Submit -->
            <button
              id="loginProvaSubmit"
              class="submit-btn"
              type="submit"
              :disabled="isLoading"
            >
              <i style="color:white" :class="{ 'fas fa-spinner fa-spin': isLoading, 'fas fa-sign-in-alt': !isLoading }"></i>

              {{ isLoading ? ' Verificando...' : ' Começar Prova' }}
            </button>
          </form>
      </div>
      <div v-else>
        <div class="info-box" style="background: #fffae6; border-left-color: #ffecb3; color: #665c00;">
          <div>	<i
                    class="fa fa-spin fa-spinner fa-1x ml-3 mt-3 mb-4"
                    style="color: coral">
                </i> Verificando conexão com o agente habilite-se...</div>
        </div>
      </div>

      <div class="footer-text">
        © {{ currentYear }} <strong>Habilite-se</strong><br />
        Todos Direitos Reservados
      </div>
    </div>
  </div>
  </div>
</template>



<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { Head, router } from '@inertiajs/vue3'

const cpf = ref('')
const error_login = ref('')
const isLoading = ref(false)
const wsOnline = ref(false)
const error_input = ref({})
const currentYear = new Date().getFullYear()
let websocketInstance: WebSocket | null = null;
let reconnectTimeout: ReturnType<typeof setTimeout> | null = null;

const props = defineProps({
    is_ws_verification: { type: Boolean, required: true },
});


// Aplicar máscara de CPF
const maskCPF = (value) => {
  const unmasked = value.replace(/\D/g, '')

  if (unmasked.length <= 3) {
    return unmasked
  } else if (unmasked.length <= 6) {
    return `${unmasked.slice(0, 3)}.${unmasked.slice(3)}`
  } else if (unmasked.length <= 9) {
    return `${unmasked.slice(0, 3)}.${unmasked.slice(3, 6)}.${unmasked.slice(6)}`
  } else {
    return `${unmasked.slice(0, 3)}.${unmasked.slice(3, 6)}.${unmasked.slice(6, 9)}-${unmasked.slice(9, 11)}`
  }
}

// Watcher para aplicar máscara
const handleCPFInput = (event) => {
  const value = event.target.value
  cpf.value = maskCPF(value)
}

// Submeter formulário
const handleSubmit = async () => {
  isLoading.value = true
  error_input.value = {}
  error_login.value = ''

  try {
    const response = await fetch('/loginProva', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
      },
      body: JSON.stringify({
        cpf: cpf.value
      }),
    })

    const data = await response.json()
    if (!response.ok) {
        if (data.error) {
            error_login.value = data.error
        }
        if (data.errors) {
            error_input.value = data.errors
        }
      isLoading.value = false
      return
    }

    router.visit(data.redirect)

  } catch (err) {
    console.log('error', err)
    error_login.value = 'Autenticação falhou.<br />Verifique o CPF!'
    isLoading.value = false
  }
}



function checkWS() {
    const params = new URLSearchParams(window.location.search);
    const isMaster = params.has("master");

    if (!props.is_ws_verification || isMaster) {
        wsOnline.value = true;
        return;
    }

    if (!websocketInstance) {
        const websocketURL = `ws://localhost:5901/localuuid`;
        websocketInstance = new WebSocket(websocketURL);

        websocketInstance.onopen = () => {
            console.log(`Websocket conectado - URL: ${websocketURL}`);
            wsOnline.value = true;
            if (reconnectTimeout) {
                clearTimeout(reconnectTimeout);
                reconnectTimeout = null;
            }
        };

        websocketInstance.onclose = (event) => {
            console.log('Conexão fechada - Código de Status:', event.code);
            wsOnline.value = false;
            websocketInstance = null; // 🔑 resetar aqui
            reconnectTimeout = setTimeout(() => {
                console.log('Tentando reconectar...');
                checkWS();
            }, 2000);
        };

        websocketInstance.onerror = (event) => {
            console.log('Erro na conexão:', event);
            wsOnline.value = false;
            websocketInstance = null; // 🔑 resetar aqui
            reconnectTimeout = setTimeout(() => {
                console.log('Tentando reconectar...');
                checkWS();
            }, 2000);
        };
    }
}


onMounted(() => {
    // Foco automático no campo CPF
    document.getElementById('cpf')?.focus()
    checkWS()
    setTimeout(() => {
        checkWS()
    }, 1000);


})
</script>

<style>

.login-page-wrapper {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: linear-gradient(135deg, #0a2535 0%, #0d3a52 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
}

.login-container {
  width: 100%;
  max-width: 460px;
  padding: 20px;
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 48px 32px;
  backdrop-filter: blur(10px);
  /* sem transform por padrão */
}

@media screen and (min-height: 800px) {
  .login-card {
    transform: scale(1.5);
    transform-origin: center;
  }
}
.logo-section {
  text-align: center;
  margin-bottom: 20px;
}

.logo-section img {
  height: auto;
  margin-bottom: 24px;
}

.login-header h1 {
  font-size: 28px;
  font-weight: 700;
  color: #0a2535;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.login-subtitle {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.info-box {
  background: #f0f7ff;
  border-left: 4px solid #0a7fbe;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 32px;
  font-size: 13px;
  color: #333;
  line-height: 1.5;
}

.form-group {
  margin-bottom: 20px;
  font-size: 16px;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #0a2535;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-group input {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 15px;
  font-family: 'Inter', sans-serif;
  transition: all 0.3s ease;
  background: #f9f9f9;
}

.form-group input:focus {
  outline: none;
  border-color: #0a7fbe;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(10, 127, 190, 0.1);
}

.form-group input.is-invalid {
  border-color: #dc3545;
  background: #fff;
}

.form-group input.is-invalid:focus {
  box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.1);
}

.form-group input::placeholder {
  color: #999;
}

.field-error {
  display: block;
  color: #dc3545;
  font-size: 12px;
  font-weight: 500;
  margin-top: 6px;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.submit-btn {
  width: 100%;
  padding: 14px 24px;
  background:  #ff662a;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  margin-top: 28px;
  text-transform: uppercase;
  box-shadow: 0 8px 24px rgba(10, 127, 190, 0.3);
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(10, 127, 190, 0.4);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submit-btn i {
  margin-right: 8px;
}

.footer-text {
  text-align: center;
  font-size: 12px;
  color: #999;
  margin-top: 24px;
  border-top: 1px solid #eee;
  padding-top: 24px;
}

.footer-text strong {
  color: #0a2535;
}

@media (max-width: 480px) {
  .login-card {
    padding: 32px 20px;
  }

  .login-header h1 {
    font-size: 24px;
  }

  .logo-section img {
    max-width: 100px;
  }
}
</style>
